import React from 'react'
import Card, { TitleCard } from '../../core/Card'
import { BackIcon, MarkerIcon, HomeIcon, Icon } from '../../core/icons'
import { Popconfirm, Form, Input, AutoComplete, Select, Button, Icon as AIcon, Alert, Row, Col } from 'antd';
import { Field } from 'redux-form'
import makeField from '../makeField'
import FavePlacePicker from './AutoComplete'
import './Place.css'
const Option = Select.Option;

const AInput = makeField(Input)
const ASelect = makeField(Select)
const AAutoComplete = makeField(AutoComplete)

const iconNames =  [
            "Office",
            "Home",
            "Shop",
            "Restaurant",
            "Clinic",
            "Transit",
            "Factory",
            "Bungalow",
            "Palace",
            "Treehouse",
            "Lighthouse",
            "Pagoda",
            "Marker"
        ]

const Place = ({initialValues, hideTitleBar, error, hasName, address, title, buttonTitle, onRemoteSubmit, onDelete, pristine, disabled, submitting})=>{
  if (hideTitleBar) return (
    <div className="Place" style={{width:'100%'}}>

      <Field label="Icon"
        name="icon_name"
        component={ASelect}
        type="input"
        style={{ width: '100%' }}
        formLayout="horizontal"
        >
          {iconNames.map(name=> <Option title={name} className="icon-dropdown-option" value={name}><Icon type={name} width='40' height='40'/></Option> )}
        </Field>

        <Form.Item
          labelCol={{
            xs: { span: 24 },
            sm: { span: 8 },
          }}
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 14 },
          }}
          label={'Address'}
          >
            {!address && <FavePlacePicker disabled  defaultValue={address} hasName={hasName}/>}
            {address && <FavePlacePicker disabled  defaultValue={address} hasName={hasName}/>}
          </Form.Item>

          <Field label="Place Name"
            name="name"
            component={AInput}
            type="input"
            style={{ width: '100%' }}
            formLayout="horizontal"
            placeholder="Enter a name for your favorite place"
          />
          <Row>
            <Col span={8}></Col>
            <Col span={14}>
              <Button style={{float:'right'}} loading={submitting} disabled={pristine || disabled} onClick={onRemoteSubmit} type="primary">{buttonTitle}</Button>

            </Col>
          </Row>
          {error && <Alert message={error} type="error" />}
    </div>
  )
  return (
    <div className="Place">
      <TitleCard showBackButton>
        <h1>{title}</h1>
        <Button loading={submitting} disabled={pristine || disabled} onClick={onRemoteSubmit} type="primary">{buttonTitle}</Button>
        {error && <Alert message={error} type="error" />}
        { onDelete &&
          <Popconfirm title="Are you sure?" placement="left" onConfirm={onDelete} onCancel={()=>{console.log("canceled");}} okText="Yes" cancelText="No">
            <Button type="danger" icon="delete"></Button>
          </Popconfirm>
        }
      </TitleCard>

      <Card>
        <Field label="Icon"
          name="icon_name"
          component={ASelect}
          type="input"
          style={{ width: 70 }}
          formLayout="horizontal"
          >
            {iconNames.map(name=> <Option title={name} className="icon-dropdown-option" value={name}><Icon type={name} width='40' height='40'/></Option> )}
          </Field>

          <Form.Item
            labelCol={{
              xs: { span: 24 },
              sm: { span: 8 },
            }}
            wrapperCol={{
              xs: { span: 24 },
              sm: { span: 14 },
            }}
            label={'Address'}
            >
              {!address && <FavePlacePicker  defaultValue={address} hasName={hasName}/>}
              {address && <FavePlacePicker  defaultValue={address} hasName={hasName}/>}
            </Form.Item>

            <Field label="Place Name"
              name="name"
              component={AInput}
              type="input"
              formLayout="horizontal"
              placeholder="Enter a name for your favorite place"
            />

          </Card>
        </div>

  )
}

export default Place



// WEBPACK FOOTER //
// ./src/account/favorite-places/Place.jsx